import { Injectable } from '@angular/core';
import { LoggerService } from '../../telemetry/logger.service';
import { StoredStateData } from 'src/app/driver/storage/models/stored-state-data';
import { indexedDb } from 'src/app/dexie/indexed-db-data-store';
import { BaseRepository } from 'src/app/repository/base.repository';

/**
 * Provides access to and management of state data for the dispatched service data.
 * Handles storage, retrieval, and updates of state data for dispatched services.
 * Has a caching layer to reduce the number of calls to local storage during retrieval.
 *
 * **THIS REPOSITORY HAS A CACHE LAYER**
 * **Direct access to the this class should not be used. All requests should go through @see {StateDataRepositoryCacheManager}**
 */
@Injectable({
	providedIn: 'root'
})
export class StateDataRepository extends BaseRepository<StoredStateData> {
	/**
	 * @constructor
	 *
	 * @param logger The logging service.
	 */
	constructor(
		logger: LoggerService
	) {
		super(indexedDb.StateData, logger);
	}
}